import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";

import {
    MultiSelect,
    DropDownList,AutoComplete
} from '@syncfusion/ej2-dropdowns';
import {
    loadCldr,
    L10n,
    setCulture,
    registerLicense
} from '@syncfusion/ej2-base';


registerLicense('License key');
import {
    fr
} from '@syncfusion/ej2-locale/src/fr.json';
import {
    Day,
    Week,
    WorkWeek,
    Month,
    Agenda,
    Schedule,
    DragAndDrop,
    Resize
} from '@syncfusion/ej2-schedule';
setCulture('fr');
// Injecter les vues nécessaires dans le Scheduler
Schedule.Inject(Day, Week, WorkWeek, Month, Agenda, DragAndDrop, Resize);

registerLicense("ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Xd0xjXXtYcXdUTmFc");

// Charger les fichiers de localisation
loadCldr(require('../cldr-data/main/fr/ca-gregorian.json'));
loadCldr(require('../cldr-data/main/fr/ca-generic.json'));
loadCldr(require('../cldr-data/main/fr/timeZoneNames.json'));
loadCldr(require('../cldr-data/main/fr/dateFields.json'));
loadCldr(require('../cldr-data/main/fr/numbers.json'));
loadCldr(require('../cldr-data/main/fr/numberingSystems.json'));

// Appliquer les fichiers de localisation pour la langue française
L10n.load({
    'fr': fr
});



export default class extends ApplicationController {

    static targets = ["hm0_output"];


    connect() {




        console.log("CompteRendu JS en cours ...");

        console.log("Current app", this.current_app);
        console.log("TimeZone", this.timezone);

        super.connect();
        StimulusReflex.register(this);

        if (
            $("#scheduler")
        ) {
            //on est sur le show
            ////scheduler.showSpinner();
            this.loadScheduler();








        }


        if ($("#search").length && $("#quick_sort").length) {

            this.rerender();
            (function($) {
                $.each(["show", "hide"], function(i, ev) {
                    var el = $.fn[ev];
                    $.fn[ev] = function() {
                        this.trigger(ev);
                        return el.apply(this, arguments);
                    };
                });
            })(jQuery);
            $("#spinner").on("show", function() {
                $("#total_entries").hide();
            });
            $("#spinner").on("hide", function() {
                $("#total_entries").show();
            });

            $("#mySidebar #table_custom_ .switch input").each(function() {
                let me = $(this);
                if (
                    me.attr("type") === "checkbox" &&
                    me.attr("class").includes("preference_columns")
                ) {
                    me[0].addEventListener("change", (e) => {
                        let hiddenHtmlClass = e.target.id.replace("filterrific_", "");
                        console.log(hiddenHtmlClass);
                        if (e.target.checked) {
                            console.log("show ", e.target);
                            $("." + hiddenHtmlClass).show();
                        } else {
                            console.log("hide ", e.target);
                            $("." + hiddenHtmlClass).hide();
                        }
                    });
                }
            });
            /////


            var targetElement = document.getElementById("mySidebar");
            targetElement.addEventListener("scroll", (event) => {
                var element = document.getElementById("mySidebar");
                document.getElementById("scrollevel").value = element.scrollTop;
            });

            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            const compteRenduParam = url.searchParams.get("previous_record");

            if (compteRenduParam != null) {
                var trElement = $("#compte_rendu_" + compteRenduParam);
                $("#compte_rendu_" + compteRenduParam + " td").addClass("highlighted-td");
                $("#compte_rendu_" + compteRenduParam).get(0).scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        }
    }


    async loadScheduler() {

        var eventsContainer = document.getElementById('events_data_container');
        var jsonData = eventsContainer ? eventsContainer.getAttribute('data-compte-rendu-eventjson') : null;
        if (jsonData) {
            console.log("jsonData est bien défini", jsonData);
            var parsedData = JSON.parse(jsonData);

            if (this.current_app) {
                //console.log(parsedData);
                this.eventsData = parsedData;
                this.initializeScheduler(this.eventsData, this.current_app,this.timzeone).then((sche) => {

                    this.scheduler = sche;


                    console.log("La réponse de de initializeScheduler ::> ", sche);
                    console.log("La réponse de de initializeScheduler ::> ", this.scheduler);


                    this.scheduler.eventSettings.dataSource = this.eventsData;


                    let selectedDateParam = this.getParameterByName("filterrific[with_pf_date_heure_debut_inf]");


                    let currentView = this.getParameterByName("filterrific[current_view]");


                    console.log("selectedDateParam selectedDateParam ");
                    console.log("selectedDateParam selectedDateParam ");
                    console.log("selectedDateParam selectedDateParam ");
                    console.log("selectedDateParam selectedDateParam ", selectedDateParam);
                    console.log("selectedDateParam selectedDateParam ");
                    console.log("selectedDateParam selectedDateParam ");


                    // if (selectedDateParam) {
                    /// this.scheduler.selectedDate = selectedDateParam;
                    // }


                    if (currentView) {
                        // this.scheduler.currentView = currentView;
                    }

                });

            } else {
                console.log("Pas de current_app ");
            }
        } else {
            console.error("Aucune donnée d'événement trouvée !");
        }
    }


    convertDate(inputDate) {
        const dateObject = new Date(Date.parse(inputDate));
        const formattedDate = dateObject.toISOString().replace(/[-:.]/g, '').replace(/[TZ]/g, 'Z');
        return formattedDate;
    }

    eventToCompteRendu(event) {

        console.log("event");
        console.log(event?.RecurrenceException);
        console.log(event);
        console.log("event");

        let compte_rendu = {
            id: event?.Id,
            compte_rendu_id: event?.Id,
            objet: event?.Object,
            date_heure_debut: event?.StartTime,
            date_heure_fin: event?.EndTime,
            adresse: event?.Location,
            detail: event?.Description,
            contact_id: event?.ContactId,
            contacts: event?.Contacts,
            contact2_id: event?.Contact2Id || parseInt(self.contact2_id),
            recurrence_rule: event?.RecurrenceRule,
            //start_timezone: event?.StartTimezone,
            //end_timezone: event?.EndTimezone,
            journee_entiere: this.boolToInt(event?.IsAllDay),
            recurrence_exception: event?.RecurrenceException,
        };


        console.log("RecurrenceException est peut-être dedans:", compte_rendu);
        console.log("RecurrenceException est peut-être dedans:", compte_rendu.recurrence_exception);




        return compte_rendu;
    }

    intToBool(val) {
        switch (val) {
            case 1:
                return true;
            case 2:
                return false;
            default:
                return false;
        }
    }

    boolToInt(boolValue) {
        return boolValue ? 1 : 2;
    }



    /*httpGet(url, params) {
    // If parameters are provided, generate a query string from them
    if (params) {
      const queryString = Object.keys(params?.filterrific)
        .map(key => {
          const value = params?.filterrific[key];
          if (Array.isArray(value)) {
            // Handle multi-value parameter (e.g., filterrific.ids_cols)
            return value.map(item => encodeURIComponent(`filterrific[${key}][]`) + '=' + encodeURIComponent(item)).join('&');
          } else {
            return encodeURIComponent(`filterrific[${key}]`) + '=' + encodeURIComponent(value);
          }
        })
        .join('&');
      url += '?' + queryString;
    }

    // Create and send the HTTP GET request
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, false); // Use 'false' for synchronous request
    xhr.send(null);
    return xhr.responseText;
  }*/

    httpGet(url, params) {
        if (params) {
            const queryString = Object.keys(params.filterrific).map(key => {
                const value = params.filterrific[key];
                if (Array.isArray(value)) {
                    // Si la valeur est un tableau, crée une paire clé-valeur pour chaque élément du tableau
                    return value.map(val => `${encodeURIComponent(`filterrific[${key}][]`)}=${encodeURIComponent(val)}`).join('&');
                } else {
                    // Sinon, traite normalement la paire clé-valeur
                    return `${encodeURIComponent(`filterrific[${key}]`)}=${encodeURIComponent(value)}`;
                }
            }).join('&');

            url += '?' + queryString;
        }

        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, false);
        xhr.send(null);
        return xhr.responseText;
    }


    getCurrentMonthParams() {
        // Obtention de la date d'aujourd'hui
        var today = new Date();

        // Obtention du premier jour du mois
        var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // Obtention du dernier jour du mois
        var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        // Formatage des dates au format ISO 8601
        let startDate = firstDayOfMonth.toISOString();
        let endDate = lastDayOfMonth.toISOString();

        // Création de l'objet params
        var params = {
            filterrific: {
                with_pf_date_heure_debut_inf: startDate,
                with_pf_date_heure_fin_sup: endDate,
                with_pf_recurrence: "recurrence_rule"
            }
        };

        // Renvoi de l'objet params
        return params;
    }

    // Définir les fonctions en dehors de actionBegin
    showLoader() {
        requestAnimationFrame(function() {
            console.log("LOg requestAnimationFrame");
            $('.child-loader').show();
            document.getElementById('child-loader').style.display = 'block';
        });
    }

    hideLoader() {
        setTimeout(function() {
            $('.child-loader').hide();
        }, 50);
    }

    cancelToolbarItemRendering(args) {
        // Empêcher le rechargement des données lors de la navigation
        if (args.requestType === 'toolbarItemRendering') {
            args.cancel = true;
        }
    }

    handleEventCreate(args, current_app) {
        console.log(args);
        let eventData = args?.data[0];
        let compte_rendu = this.eventToCompteRendu(eventData);
        var self = this;

        $.ajax({
            url: current_app + '/compte_rendus/create_event',
            method: 'POST',
            data: {
                compte_rendu_id: eventData?.Id,
                compte_rendu: compte_rendu
            },
            success: function(response) {
                console.log('Event created successfully:', response);
                let selectedIndex = self.eventsData.findIndex(event => event.Id === eventData?.Id);
                if (selectedIndex !== -1) {
                    console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                    self.eventsData[selectedIndex] = response.data;
                    self.scheduler.eventSettings.dataSource = self.eventsData;
                    self.scheduler.refreshEvents();
                } else {
                    console.error('Événement sélectionné non trouvé dans eventsData.');
                    let selectedIndex = self.eventsData.findIndex(event => event.Id === eventData?.Id);
                    self.eventsData.splice(selectedIndex, 1);
                    self.eventsData.push(response.data);
                    self.scheduler.eventSettings.dataSource = self.eventsData;
                    self.scheduler.refreshEvents();

                }

                self.hideLoader();
            },
            error: function(xhr, status, error) {
                console.error('Error create event:', status);
                if (status == 404) {
                    // Gérer les erreurs 404 si nécessaire
                }
                self.hideLoader();
            }
        });
    }

    handleEventChange(args, current_app) {
        let eventData = args?.changedRecords[0];
        let compte_rendu = this.eventToCompteRendu(eventData);
        var self = this;
        async function updateEvent() {
            try {
                const response = await $.ajax({
                    url: current_app + '/compte_rendus/update_event',
                    method: 'PATCH',
                    data: {
                        compte_rendu_id: eventData.Id,
                        compte_rendu: compte_rendu
                    }
                });

                console.log('Event updated successfully:', response.message);
                let selectedIndex = self.eventsData.findIndex(event => event.Id === eventData?.Id);
                if (selectedIndex !== -1) {
                    console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                    self.eventsData.splice(selectedIndex, 1);
                    self.eventsData.push(response.data);
                    self.scheduler.eventSettings.dataSource = self.eventsData;
                    console.log(self.eventsData);
                    self.scheduler.refresh();
                } else {
                    console.error('Événement sélectionné non trouvé dans eventsData.');
                }
            } catch (error) {
                console.log('Error updating event:', error);
                // Gérer les erreurs ici si nécessaire
            } finally {
                self.hideLoader();
            }
        }

        updateEvent().then(() => {
            self.scheduler.refreshEvents();
        }).catch(error => {
            console.error('Error during event update:', error);
            // Gérer les erreurs ici si nécessaire
        });
    }

    handleEventRemove(args, current_app) {
        var self = this;
        if (args?.data[0]?.parent) {
            let recurrence_exception = args?.data[0]?.parent.RecurrenceException + "," + self.convertDate(args?.data[0]?.occurrence.StartTime);

            $.ajax({
                url: current_app + '/compte_rendus/update_event',
                method: 'PATCH',
                data: {
                    compte_rendu_id: args?.data[0]?.parent?.Id,
                    compte_rendu: {
                        id: args?.data[0]?.parent?.Id,
                        recurrence_exception: recurrence_exception
                    }
                },
                success: function(response) {
                    console.log('Event updated successfully:', response);
                    let selectedIndex = self.eventsData.findIndex(event => event.Id === args?.data[0]?.parent?.Id);
                    if (selectedIndex !== -1) {
                        console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                        self.eventsData[selectedIndex] = response.data;
                        self.scheduler.eventSettings.dataSource = self.eventsData;
                        console.log(self.eventsData);
                    } else {
                        console.error('Événement sélectionné non trouvé dans eventsData.');
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Error update event:', status);
                    if (status == 404) {
                        // Gérer les erreurs 404 si nécessaire
                    }
                }
            });
        } else {
            var eventData = args?.data[0];

            $.ajax({
                url: current_app + '/compte_rendus/' + eventData?.Id + '/delete_event',
                method: 'DELETE',
                success: function(response) {
                    console.log('Event deleted successfully:', response);
                    let selectedIndex = self.eventsData.findIndex(event => event.Id === eventData?.Id);
                    if (selectedIndex !== -1) {
                        console.log('Index de l\'événement sélectionné dans eventsData :', selectedIndex);
                        self.eventsData.splice(selectedIndex, 1);
                        sefl.scheduler.eventSettings.dataSource = self.eventsData;
                        self.scheduler.refreshEvents();
                    } else {
                        console.error('Événement sélectionné non trouvé dans eventsData.');
                    }

                    self.hideLoader();
                },
                error: function(xhr, status, error) {
                    self.hideLoader();
                    console.error('Error deleting event:', status);
                    // Gérer les erreurs de suppression d'événement si nécessaire
                }
            });
        }
    }


    getCurrentWeekParams() {
        // Obtention de la date d'aujourd'hui
        var today = new Date();

        // Obtention du jour de la semaine (0 pour dimanche, 1 pour lundi, ..., 6 pour samedi)
        var dayOfWeek = today.getDay();

        // Calcul du décalage pour obtenir le début de la semaine (dimanche)
        var startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - dayOfWeek);

        // Calcul du décalage pour obtenir la fin de la semaine (samedi)
        var endOfWeek = new Date(today);
        endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));

        // Formatage des dates au format ISO 8601
        let startDate = startOfWeek.toISOString();
        let endDate = endOfWeek.toISOString();

        // Création de l'objet params
        var params = {
            filterrific: {
                with_pf_date_heure_debut_inf: startDate,
                with_pf_date_heure_fin_sup: endDate,
                with_pf_recurrence: "recurrence_rule"
            }
        };

        // Renvoi de l'objet params
        return params;
    }



    numberToHexColor(number) {
        // Limiter la plage des valeurs RVB pour éviter des couleurs trop sombres ou trop claires
        var red = (number % 128) + 128; // Rouge dans la plage 128-255
        var green = ((number >> 8) % 128) + 128; // Vert dans la plage 128-255
        var blue = ((number >> 16) % 128) + 128; // Bleu dans la plage 128-255

        // Convertir les valeurs RVB en une couleur hexadécimale
        var hex = ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1);

        // Préfixer avec '#' pour obtenir une couleur hexadécimale valide
        return "#" + hex;
    }


    callDataFetcher(event) {

        this.fetchEventData(event).then((sched) => {

            console.log("la reponse calDataFetcher ====>", sched);


            this.scheduler.refresh();
        })
    }


    async fetchEventData(args) {


        var sObj = document.querySelector(".e-schedule").ej2_instances[0];

        try {

            let sObj = document.querySelector(".e-schedule").ej2_instances[0];
            let currentDates = sObj.getCurrentViewDates();

            let currentViewOption = sObj.getActiveViewOptions();
            let startDate = currentDates[0];
            let endDate = currentDates[currentDates.length - 1];


            document.getElementById('with_pf_date_heure_debut_inf').value = startDate;
            document.getElementById('with_pf_date_heure_fin_sup').value = endDate;
            document.getElementById('with_current_view').value = currentViewOption?.option;
            this.updateUrlParameter('filterrific[with_pf_date_heure_debut_inf]', new Date(startDate).toISOString().slice(0, 10));


            if (startDate && !isNaN(new Date(startDate).getTime())) {
                this.updateUrlParameter('filterrific[with_pf_date_heure_debut_inf]', new Date(startDate).toISOString().slice(0, 10));
                // Utilisez formattedStartDate pour d'autres opérations
            } else {
                console.log(startDate);

                console.error('startDate n\'est pas une date valide.');
            }


            if (endDate && !isNaN(new Date(endDate).getTime())) {
                this.updateUrlParameter('filterrific[with_pf_date_heure_fin_sup]', new Date(endDate).toISOString().slice(0, 10));
                // Utilisez formattedStartDate pour d'autres opérations
            } else {
                console.log(endDate);
                console.error('startDate n\'est pas une date valide.');
            }



            var params = {
                filterrific: {
                    with_pf_date_heure_debut_inf: startDate,
                    with_pf_date_heure_fin_sup: endDate,
                    with_pf_recurrence: "recurrence_rule"
                }
            };




            console.log("args de fetchEventData  est ::::::::: ", args);



           /* if (args && args?.target) {
                organisateurs = this.toggleItemInArray(organisateurs, args?.target?.id)
            }*/

            let organisateurs = [];
            let  checkedCheckboxes = document.querySelectorAll('input[name="filterrific[with_organisateur_or_participant_mult][]"]:checked');
            checkedCheckboxes.forEach(function(checkbox) {
                organisateurs.push(checkbox.value);
            });




            this.updateUrlParameter('filterrific[with_organisateur_or_participant_mult][]', organisateurs);
            params.filterrific['with_organisateur_or_participant_mult'] = organisateurs;


            // Effectuer une requête pour récupérer les nouveaux événements

            this.eventsData = await JSON.parse(this.httpGet(this.current_app + "/compte_rendus/calendar.json", params));
            console.log("Données d'événement récupérées :", this.eventsData);


            console.log("eventsData eventsData eventsData eventsData de fetchEventData", this.eventsData)
            // Mettre à jour les événements affichés dans le calendrier

        } catch (error) {
            console.error("Une erreur s'est produite lors de la récupération des données des événements :", error);
            throw error; // Renvoyer l'erreur pour la gérer à l'extérieur de cette fonction si nécessaire

        } finally {

            sObj.eventSettings.dataSource = this.eventsData;
            sObj.refreshEvents();
            this.hideLoader();
            return sObj;
        }
    }



    toggleItemInArray(array, item) {


        console.log("Jelooo , ici", item);
        const index = array.indexOf(item);

        if (index !== -1) {
            // Item exists in the array, remove it
            array.splice(index, 1);
        } else {
            // Item does not exist in the array, add it
            array.push(item);
        }

        return array;
    }


    /*updateUrlParameter(key, value) {
    // Obtenez les paramètres d'URL actuels
    const urlParams = new URLSearchParams(window.location.search);

    // Vérifiez si le paramètre existe déjà
    if (!urlParams.has(key)) {
        // Si le paramètre n'existe pas, ajoutez-le
        urlParams.append(key, value);
    } else {
        // Si le paramètre existe déjà, mettez à jour sa valeur
        urlParams.set(key, value);
    }

    // Convertir les paramètres mis à jour en chaîne de requête
    const updatedParams = urlParams.toString();

    // Construire la nouvelle URL avec les paramètres mis à jour
    const newUrl = `${window.location.origin}${window.location.pathname}?${updatedParams}`;

    // Remplacer l'URL actuelle dans l'historique du navigateur sans recharger la page
    window.history.replaceState({ path: newUrl }, '', newUrl);
} */

    updateUrlParameter(key, value) {
        // Get current URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Check if the parameter exists
        if (urlParams.has(key)) {
            // Clear the existing parameter (if any)
            urlParams.delete(key);
        }

        // If value is an array, handle multi-value case
        if (Array.isArray(value)) {
            value.forEach(item => urlParams.append(key, item));
        } else {
            // If value is not an array, handle single-value case
            urlParams.append(key, value);
        }

        // Convert updated parameters to query string
        const updatedParams = urlParams.toString();

        // Construct the new URL with updated parameters
        const newUrl = `${window.location.origin}${window.location.pathname}?${updatedParams}`;

        // Replace current URL in browser history without reloading
        window.history.replaceState({
            path: newUrl
        }, '', newUrl);
    }


    getParameterByName(parameterName, url = window.location.href) {
        // Use provided URL or current location
        const searchParams = new URLSearchParams(url.substring(url.indexOf("?") + 1));

        // Get parameter values as an array
        const parameterValues = searchParams.getAll(parameterName);

        // Return empty array if no values found
        if (!parameterValues) {
            return [];
        }

        // Return the array of values without conversion
        return parameterValues;
    }


    async initializeScheduler(eventsData, current_app,userTimeZone) {

        var self = this; // Stocker la référence au contexte this

        var schedulerElement = document.getElementById('scheduler');

        if (!schedulerElement) {
            console.error("Élément de planificateur introuvable !");
            return;
        } else {
            console.error("Élément de planificateur est là !");
        }


        console.log("scheduler", scheduler);
        var scheduler = await new Schedule({
            locale: this.local,
            width: '100%',
            height: '85vh',
            currentView: "Week",
            showHeaderBar: true,
            enablePersistence: true,
            allowDragAndDrop: true,
            firstDayOfWeek: 1,
            timezone: userTimeZone,
            workHours: {
                highlight: true,
                start: '09:00',
                end: '18:00'
            },
            startHour: "9",
            endHour: "18",
            views: ["Day", "Week", "WorkWeek", "Month", "Agenda"],
            eventSettings: {
                dataSource: eventsData,
                fields: {
                    subject: {
                        floatLabelType: 'Always',
                        name: 'Object',
                        validation: {
                            required: true
                        }
                    },
                    StartTime: {
                        validation: {
                            required: true
                        }

                    },
                    EndTime: {
                        validation: {
                            required: true
                        }
                    }
                }
            },
            eventRendered: function(args) {
                args.element.style.backgroundColor = args.data.Color;

                args.element.querySelector('.e-subject').innerText = args.data?.Sil;

                // Supprimer l'affichage du lieu du rendez-vous
                // args.element.querySelector('.e-location').style.display = 'none';

            },
            dataBinding: function(args) {

                console.log("Bonjour les dara", args);
            },
            actionComplete: async function(args) {

                self.showLoader();
                if (args.requestType == "dateNavigate" || args.requestType == "viewNavigate") {
                    args.cancel = false;
                    console.log("args dans actionComplete actionComplete", args)

                    let sched = await self.fetchEventData();

                    console.log("self.scheduler self.scheduler self.scheduler", self.scheduler);
                    console.log("self.scheduler self.scheduler self.scheduler", self.scheduler);



                }
            },
            dataBound: function() {
                setTimeout(function() {
                    self.hideLoader();
                }, 50);

            },
          actionBegin: function(args) {


            if (args.data?.IsReadonly) {
              args.cancel = true;

            } else {
              self.showLoader();
              switch (args.requestType) {
                case 'eventCreate':
                  self.handleEventCreate(args, current_app);
                  break;
                case 'eventChange':
                  self.handleEventChange(args, current_app);
                  break;
                case 'eventRemove':
                  self.handleEventRemove(args, current_app);
                  break;
                default:
                  break;
              }
            }
          },
          popupClose: async function(args){
          console.log(args);
},

            popupOpen: async function(args) {


                if (args.type === 'QuickInfo') {
                    args.element.querySelector('.e-subject').innerText = args.data?.Sil;
                    var popupContent = args.element.querySelector('.e-popup-content');

                    // Ajouter l'élément "Contact2" si Contact2Id est défini
                    if (popupContent && args.data?.Contact2Id && args.data?.Contact2?.text) {
                        var contact2Element = document.createElement('div');
                        contact2Element.classList.add('e-time-zone');
                        contact2Element.innerHTML = '<div class="fa fa-user-cog  fx-text-grey mb-auto fx-fs-18 me-3 mt-auto"></div><div class="e-time-zone-details e-text-ellipsis">' + self.organisateur_label + ": " + args.data.Contact2.text + '</div>';
                        if (popupContent) {
                            popupContent.appendChild(contact2Element);
                        }
                    }

                 // Ajouter l'élément "Contact" si ContactId est défini
                 if (popupContent && args.data?.ContactId && args.data?.Contact?.text) {
                     var contactElement = document.createElement('div');
                     contactElement.classList.add('e-time-zone', 'fx-fs-14');

                     var newUrl = `${window.location.origin}/${self.current_app}/contacts/show?contact_id=${args.data?.ContactId}`;

                     // Créer un élément d'ancrage cliquable pour le texte du contact
                     var contactLink = document.createElement('a');
                     contactLink.href = newUrl; // URL cible
                     contactLink.target = '_blank'; // Ouvrir dans un nouvel onglet
                     contactLink.textContent = args.data.Contact.text; // Texte du contact
                     contactLink.classList.add('fx-fs-14', 'ms-1');

                     // Ajouter l'icône et les détails à l'élément contact
                     var iconElement = document.createElement('div');
                     iconElement.classList.add('fa', 'fa-user-check', 'fx-text-grey', 'mb-auto', 'me-3', 'fx-fs-18', 'mt-auto');

                     // Ajouter le texte du label et le lien dans le même div
                     var contactLabelAndLink = document.createElement('div');
                     contactLabelAndLink.appendChild(document.createTextNode(self.contact_label + ": "));
                     contactLabelAndLink.appendChild(contactLink);

                     // Ajouter l'icône et le texte du label avec le lien dans contactElement
                     contactElement.appendChild(iconElement);
                     contactElement.appendChild(contactLabelAndLink);

                     // Ajouter contactElement à popupContent
                     if (popupContent) {
                         popupContent.appendChild(contactElement);
                     }
                 }


                    // Ajouter l'élément "Contacts3" pour afficher tous les contacts sur la même ligne séparés par des virgules
                    if (popupContent && args.data?.Contacts3 && args.data?.Contacts3.length > 0) {
                        var contacts3Element = document.createElement('div');
                        contacts3Element.classList.add('e-time-zone');
                        var contacts3Text = args.data.Contacts3.map(contact => contact.nom + ' ' + contact.prenom).join(', ');
                        contacts3Element.innerHTML = '<div class="fa fa-users fx-text-grey fx-fs-18 mb-auto me-3 mt-auto"></div><div class="e-time-zone-details e-text-ellipsis">' + self.participants_label + ': ' + contacts3Text + '</div>';
                        if (popupContent) {
                            popupContent.appendChild(contacts3Element);
                        }
                    }


                    // On vérifie que popupContent existe ET qu'au moins un des deux IDs est présent
                    if (popupContent && (args.data?.InterventionId || args.data?.ContactId)) {
                        var compteRenduElement = document.createElement('div');
                        compteRenduElement.classList.add('e-time-zone');

                        var lienTexte, compteRenduUrl;

                        // Priorité à l'intervention si elle existe, sinon on bascule sur le contact
                        if (args.data?.InterventionId) {
                            lienTexte = 'Voir l\'intervention';
                            compteRenduUrl = `${window.location.origin}/${self.current_app}/interventions/${args.data.InterventionId}`;
                        } else {
                            lienTexte = 'Voir le contact';
                            compteRenduUrl = `${window.location.origin}/${self.current_app}/contacts/show?contact_id=${args.data.ContactId}`;
                        }

                        // Créer un élément d'ancrage cliquable
                        var compteRenduLink = document.createElement('a');
                        compteRenduLink.href = compteRenduUrl;
                        compteRenduLink.target = '_blank';
                        compteRenduLink.textContent = lienTexte;
                        compteRenduLink.classList.add('fx-fs-14');

                        // Structure HTML de l'élément
                        compteRenduElement.innerHTML = '<div class="fx-link fa fa-external-link fx-text-grey mb-auto me-3 mt-auto"></div>';
                        compteRenduElement.appendChild(compteRenduLink);

                        popupContent.appendChild(compteRenduElement);
                    }



                }


                if (args.type === 'Editor') {

                    let formElement = args.element.querySelector('.e-schedule-form');


                    if (formElement) {
                        let existingRow = args.element.querySelector('.custom-field-container');
                        if (!existingRow) {
                            let container = document.createElement('div');
                            container.className = 'custom-field-container';
                            container.classList.add('fx-text-left');
                            
                            let inputEleOrganisateur = document.createElement('input');
                            inputEleOrganisateur.className = 'e-field';
                            inputEleOrganisateur.setAttribute('name', 'Contact2Id');
                            inputEleOrganisateur.setAttribute('placeholder', self.organisateur_label);
                        
                            let inputEleContact = document.createElement('input');
                            inputEleContact.className = 'e-field';
                            inputEleContact.setAttribute('name', 'ContactId');
                            inputEleContact.setAttribute('placeholder', self.contact_label);
                            //inputEleContact.setAttribute('aria-required', true); inputEleContact.setAttribute('required', true);

                            let multiSelectContacts = document.createElement('input');
                            multiSelectContacts.className = 'e-field';
                            multiSelectContacts.setAttribute('name', 'Contacts');
                            multiSelectContacts.setAttribute('placeholder', self.participants_label);

                            container.appendChild(inputEleOrganisateur);
                            container.appendChild(inputEleContact);
                            container.appendChild(multiSelectContacts);




                            // Ajoutez un gestionnaire d'événement pour la soumission du formulaire
                            formElement.addEventListener('submit', function(event) {
                                // Vérifiez si le champ "Contact" est vide
                                if (!inputEleContact.value) {
                                    // Empêchez la soumission du formulaire
                                    event.preventDefault();
                                    // Affichez un message d'erreur ou prenez toute autre action appropriée
                                    alert('Veuillez sélectionner un contact.');
                                }
                            });

                            // Faire une requête AJAX pour récupérer les options filtrées pour l'organisateur
                            await fetch(current_app + '/compte_rendus/get_organisateur_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });
                        
                                    // Utiliser les données formatées dans votre DropDownList pour l'organisateur
                                    let drowDownListOrganisateur = new DropDownList({
                                        dataSource: formattedData,
                                        floatLabelType: 'Always',
                                        placeholder: self.organisateur_label,
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: args?.data?.Contact2Id || parseInt(self.contact2_id)
                                    });
                        
                                    drowDownListOrganisateur.appendTo(inputEleOrganisateur);

                             })
                             .catch(error => console.error('Error fetching filtered options for Organisateur:', error));



                            // Faire une requête AJAX pour récupérer les options filtrées pour l'organisateur
                            await fetch(current_app + '/compte_rendus/get_participant_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                let multiSelectObject = new MultiSelect({
                                    dataSource: formattedData,
                                    floatLabelType: 'Always',
                                    placeholder: this.participants_label,
                                    fields: {
                                        text: 'text',
                                        value: 'value'
                                    },
                                    value: args?.data?.Contacts || []
                                });
                                multiSelectObject.appendTo(multiSelectContacts);
                                })
                                .catch(error => console.error('Error fetching filtered options for Organisateur:', error));





                            // Faire une requête AJAX pour récupérer les options filtrées pour le contact
                            await fetch(current_app + '/compte_rendus/get_contact_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour le contact
                                    let drowDownListContact = new DropDownList({
                                        dataSource: formattedData,
                                        floatLabelType: 'Always',
                                        placeholder: self.contact_label,
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: args?.data?.ContactId,
                                    });
                                    drowDownListContact.appendTo(inputEleContact);
                                })
                                .catch(error => console.error('Error fetching filtered options for Contact:', error));


                            formElement.insertBefore(container, formElement.firstChild);
                        }
                    }
                }


                if (args.type === 'QuickInfo') {
                    // Créer les éléments personnalisés requis lors de l'ouverture de QuickInfo
                    //args.element.querySelector('.e-subject').setAttribute('name', 'Object');
                    let formElement = args.element.querySelector('.e-schedule-form');
                    let titleElement = args.element.querySelector('.e-subject');
                    if (titleElement) {
                        titleElement.setAttribute('required', 'true');
                        titleElement.setAttribute('value', args?.data?.objet ?? "");
                        titleElement.style.fontSize = '13px';
                    }
                    if (formElement) {
                        let existingRow = args.element.querySelector('.custom-field-container');
                        if (!existingRow) {
                            // let row = document.createElement('div');
                            //row.className = 'custom-field-row';


                            let container = document.createElement('div');
                            container.className = 'custom-field-container';
                            container.classList.add('fx-text-left');

                            let inputEleOrganisateur = document.createElement('infput');
                            inputEleOrganisateur.className = 'e-field';
                            inputEleOrganisateur.setAttribute('name', 'Contact2Id');
                            inputEleOrganisateur.setAttribute('placeholder', self.organisateur_label);

                            let inputEleContact = document.createElement('input');
                            inputEleContact.className = 'e-field';
                            inputEleContact.setAttribute('name', 'ContactId');
                            inputEleContact.setAttribute('placeholder', self.contact_label);
                            //inputEleContact.setAttribute('aria-required', true); inputEleContact.setAttribute('required', true);
                            container.appendChild(inputEleOrganisateur);
                            container.appendChild(inputEleContact);
                            //row.appendChild(container);
                            let nextDivElement = container.nextElementSibling;
                            if (nextDivElement) {
                                nextDivElement.className = "custom-field-container e-control-wrapper e-ddl e-float-input e-input-group e-keyboard e-lib e-valid-input"
                            }

                            // Faire une requête AJAX pour récupérer les options filtrées pour l'organisateur
                            await fetch(current_app + '/compte_rendus/get_organisateur_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour l'organisateur
                                    let drowDownListOrganisateur = new DropDownList({
                                        dataSource: formattedData,
                                        placeholder: self.organisateur_label,
                                        floatLabelType: 'Always',
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: parseInt(self.contact2_id)
                                    });
                                    drowDownListOrganisateur.appendTo(inputEleOrganisateur);

                                })
                                .catch(error => console.error('Error fetching filtered options for Organisateur:', error));

                            // Faire une requête AJAX pour récupérer les options filtrées pour le contact
                            await fetch(current_app + '/compte_rendus/get_contact_list')
                                .then(response => response.json())
                                .then(data => {
                                    let formattedData = data.map(item => {
                                        return {
                                            text: item[0],
                                            value: item[1]
                                        };
                                    });

                                    // Utiliser les données formatées dans votre DropDownList pour le contact
                                    let drowDownListContact = new DropDownList({
                                        dataSource: formattedData,
                                        placeholder: self.contact_label,
                                        floatLabelType: 'Always',
                                        fields: {
                                            text: 'text',
                                            value: 'value'
                                        },
                                        value: args?.data?.ContactId,
                                    });
                                    drowDownListContact.appendTo(inputEleContact);
                                })
                                .catch(error => console.error('Error fetching filtered options for Contact:', error));


                            formElement.appendChild(container);
                        }
                    }
                }

            }

        });
        if (schedulerElement && schedulerElement.children.length > 2) {
            console.log("La barre d'outils du calendrier est déjà initialisée !");

            // Supprimer tous les enfants de schedulerElement sauf ceux avec les IDs spécifiés
            /*    Array.from(schedulerElement.children).forEach(child => {
                   if (child.id !== "filterrific_filter" && child.id !== "event_refresh") {
                       schedulerElement.removeChild(child);
                   }
               });  */



            console.log("schedulerElement ", schedulerElement);
            console.log("schedulerElement.children.length ", schedulerElement?.children?.length);
            console.log("schedulerElement.children ", schedulerElement?.children);

        } else {
            console.log("La barre d'outils du calendrier est initialisée !");
            scheduler.appendTo(schedulerElement);


            // Afficher l'indicateur de chargement
            scheduler.showSpinner();

            // Simuler une opération asynchrone (par exemple, une requête AJAX)
            setTimeout(function() {
                // Ici, vous pouvez effectuer votre traitement asynchrone, par exemple, une requête AJAX
                // Une fois que le traitement asynchrone est terminé, vous pouvez masquer l'indicateur de chargement
                scheduler.hideSpinner(); // Masquer l'indicateur de chargement
            }, 10000); // Dans cet exemple, j'ai mis une temporisation de 2 secondes pour simuler un traitement asynchrone
        }



        return scheduler;


    }




    get current_app() {
        return this.data.get("app");
    }
    get timezone() {
        return this.data.get("timezone");
    }
    get contact2_id() {
        return this.data.get("contact2id");
    }
    get local() {
        return this.data.get("local");
    }

    get params() {
        return this.data.get("params");
    }

    get compte_rendu_id() {
        return this.data.get("compte_renduid");
    }

    get url_solution() {
        return this.data.get("urlsolution");
    }

    get contact_label() {
        return this.data.get("contactlabel");
    }

    get participants_label() {
        return this.data.get("participantslabel");
    }

    get organisateur_label() {
        return this.data.get("organisateurlabel");
    }
}